(() => {
  const enhance = () => {
    const root = document.querySelector('#reviews-wrapper > .trustoo-widget[not-wdo-rev]');
    if (!root || root.dataset.griseCompact) return;
    const body = root.querySelector('#reviews-body');
    if (!body) return;
    root.dataset.griseCompact = 'true';
    if (window.location.pathname === '/') {
      root.dataset.griseCarousel = 'true';
      const toolbar = document.createElement('div');
      toolbar.className = 'grise-review-toolbar';
      const heading = document.createElement('h2');
      heading.textContent = 'Jūsų atsiliepimai';
      const controls = document.createElement('div');
      controls.className = 'grise-review-controls';
      const previous = document.createElement('button');
      previous.type = 'button';
      previous.setAttribute('aria-label', 'Ankstesni atsiliepimai');
      previous.textContent = '←';
      const next = document.createElement('button');
      next.type = 'button';
      next.setAttribute('aria-label', 'Kiti atsiliepimai');
      next.textContent = '→';
      const list = () => root.querySelector('.tt-review-list');
      const sync = () => {
        const track = list();
        if (!track) return;
        track.tabIndex = 0;
        track.setAttribute('role', 'region');
        track.setAttribute('aria-label', 'Klientų atsiliepimai, slinkti horizontaliai');
        const atStart = track.scrollLeft < 2;
        const atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
        if (previous.disabled !== atStart) previous.disabled = atStart;
        if (next.disabled !== atEnd) next.disabled = atEnd;
        if (!track.dataset.griseScroll) {
          track.dataset.griseScroll = 'true';
          track.addEventListener('scroll', sync, { passive: true });
        }
      };
      const move = direction => {
        const track = list();
        if (!track) return;
        const card = track.querySelector('.list-review');
        const step = card ? card.getBoundingClientRect().width + 18 : track.clientWidth;
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        track.scrollBy({ left: direction * step, behavior: reduced ? 'auto' : 'smooth' });
      };
      previous.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
      controls.append(previous, next);
      toolbar.append(heading, controls);
      root.prepend(toolbar);
      new MutationObserver(sync).observe(body, { childList: true, subtree: true });
      window.addEventListener('resize', sync);
      requestAnimationFrame(sync);
      return;
    }
    const disclosure = document.createElement('details');
    disclosure.className = 'grise-reviews-disclosure';
    const summary = document.createElement('summary');
    summary.textContent = 'Rodyti visus atsiliepimus';
    body.before(disclosure);
    disclosure.append(summary, body);
    // Keep app pagination and other list controls inside the disclosure too.
    while (disclosure.nextSibling) disclosure.append(disclosure.nextSibling);
    disclosure.addEventListener('toggle', () => {
      summary.textContent = disclosure.open ? 'Suskleisti atsiliepimus' : 'Rodyti visus atsiliepimus';
      if (disclosure.open) window.dispatchEvent(new Event('resize'));
    });
  };
  const observer = new MutationObserver(enhance);
  observer.observe(document.body, { childList: true, subtree: true });
  document.addEventListener('onTrustooReviewsEmbed', enhance);
  enhance();
})();
